import { format } from "date-fns";
import { CheckCheck, Loader2, Mail, Save, Scaling, X } from "lucide-react";
import React, { useContext } from "react";
import Icon from "~/components/Icon";

// Copied specifically for Enrollment usage
export default function FormHeader({
  loading = false,
  saveText = "Save changes",
  saveColor = null,
  saveIcon = "Save",
  outside = false,
  access = {
    view: false,
    edit: false,
    create: false,
    inactivate: false,
    MenuHierarchyXGroup: null,
  },
  title = "",
  registry = { registryBy: null, registryAt: null, registryStatus: null },
  InputContext = null,
  emailButtonText = "Send Mail",
  createText = "Create",
  createIcon = <Save size={16} />,
  enableFullScreen = true,
  otherButtons = null,
  disableSave = false,
}) {
  const { registryBy, registryAt, registryStatus } = registry;
  const {
    id,
    fullscreen,
    setFullscreen,
    successfullyUpdated,
    handleCloseForm,
    handleOutsideMail,
  } = useContext(InputContext);

  if (access.MenuHierarchyXGroup) {
    access = access.MenuHierarchyXGroup;
  }

  return (
    <div className="sm:sticky sm:top-0 sm:z-50 bg-slate-100 min-h-24 mb-4 px-4 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-2 sm:gap-0">
      <h2 className="flex flex-col justify-start items-start gap-1 text-2xl">
        {title}{" "}
        <span className="text-xs">
          {registryAt &&
            `${registryStatus} by ${registryBy} on ${format(
              registryAt,
              "LLL do, yyyy @ HH:mm"
            )}`}
        </span>
      </h2>

      <div className="flex flex-row flex-wrap justify-end items-center gap-4 w-full sm:w-auto">
        {loading ? (
          <div className="flex flex-row justify-center items-center gap-2">
            <Loader2 size={16} color="#111" className="animate-spin" />
            <div>Please wait...</div>
          </div>
        ) : (
          <>
            {!outside && access && (
              <>
                {enableFullScreen && (
                  <button
                    type="button"
                    onClick={() => setFullscreen(!fullscreen)}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap"
                  >
                    <Scaling size={16} />
                    <span className="hidden md:block ml-1">{fullscreen ? "Minimize" : "Full Screen"}</span>
                  </button>
                )}
                {(access.edit && id !== "new") ||
                (access.create && id === "new") ? (
                  <button
                    type="button"
                    onClick={() => handleCloseForm()}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap"
                  >
                    <X size={16} />
                    <span className="hidden md:block ml-1">
                    {successfullyUpdated
                      ? "Close"
                      : "Discard changes not saved"}
                    </span>
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => handleCloseForm()}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1"
                  >
                    <X size={16} />
                    <span className="hidden md:block ml-1">Close</span>
                  </button>
                )}
              </>
            )}
            {(outside || (access && access.create)) && id === "new" && (
              <button
                type="submit"
                className={`text-md font-bold ${
                  !successfullyUpdated ? "bg-mila_orange" : "bg-primary"
                } text-white rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap`}
              >
                <>
                  {createIcon} {createText}
                </>
              </button>
            )}
            {otherButtons &&
              otherButtons.map((button, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={button.onClick}
                  className={`text-md font-bold border border-dashed border-red-500 text-red-500 rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap`}
                >
                  <>
                    <Icon name={button.icon} size={16} /> {button.text}
                  </>
                </button>
              ))}
            {(outside || (access && access.edit)) && id !== "new" && (
              <button
                type="submit"
                disabled={disableSave}
                className={`text-md font-bold ${
                  disableSave
                    ? "bg-gray-300 cursor-not-allowed"
                    : !successfullyUpdated
                    ? saveColor
                      ? saveColor
                      : "bg-mila_orange"
                    : "bg-primary"
                } text-white rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap`}
              >
                {!successfullyUpdated ? (
                  <>
                    <Icon name={saveIcon} size={16} color="white" /> {saveText}
                  </>
                ) : (
                  <>
                    <CheckCheck size={16} /> {"Saved"}
                  </>
                )}
              </button>
            )}
            {!outside && handleOutsideMail && id !== "new" && (
              <button
                type="button"
                onClick={() => handleOutsideMail()}
                className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md px-4 py-2 flex flex-row items-center justify-center text-sm gap-1 whitespace-nowrap"
              >
                <Mail size={16} />
                <span className="hidden md:block ml-1">{emailButtonText}</span>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
